"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneInternational = exports.formatPhone = exports.removeNonNumbers = void 0;

var _min = require("libphonenumber-js/min");

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NUMERIC_REGEX = /[^0-9]/g;

var removeNonNumbers = function removeNonNumbers(value) {
  return value.replace(NUMERIC_REGEX, '');
};

exports.removeNonNumbers = removeNonNumbers;

var formatPhone = function formatPhone(value) {
  var numbers = removeNonNumbers(value);

  if (numbers.length > 10) {
    return "".concat(numbers.substring(0, 1), " (").concat(numbers.substring(1, 4), ") ").concat(numbers.substring(4, 7), "-").concat(numbers.substring(7));
  } else if (numbers.length > 6) {
    return "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6), "-").concat(numbers.substring(6));
  } else if (numbers.length > 3) {
    return "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6));
  }

  return numbers;
};

exports.formatPhone = formatPhone;
var formattersByCountry = {};

var formatPhoneInternational = function formatPhoneInternational(country, value) {
  if (!(country in formattersByCountry)) {
    formattersByCountry[country] = new _min.AsYouType(country);
  }

  var formatter = formattersByCountry[country];
  var formattedOutput = formatter.input(value);
  var number = (0, _lodash["default"])(formatter.getNumber(), ['metadata']);
  var template = formatter.getTemplate();
  formatter.reset();
  return {
    formattedOutput: formattedOutput,
    number: number,
    template: template
  };
};

exports.formatPhoneInternational = formatPhoneInternational;